export default __webpack_public_path__ + "static/media/Q3_3_resized.868d3335.jpg";